import React from "react";
import SearchBar from "./search_bar";
import AttachmentList from "./attachment_list";

export default class AttachmentBrowser extends React.Component {
    state = {
        search_query: null
    };

    updateSearchQuery = search_query => {
        this.setState({ search_query: search_query });
    };

    renderSearchNav() {
        return (
            <div className="adobe-attachment-browser-nav">
                <SearchBar
                    search_query={this.state.search_query}
                    updateSearchQuery={this.updateSearchQuery}
                    selected_brandfolder={this.props.selected_brandfolder}
                />
                <div
                    className="adobe-menu-toggle"
                    onClick={this.props.toggleMenu}
                >
                    <i className="fa fa-bars" />
                </div>
            </div>
        );
    }

    renderAttachmentList() {
        return (
            <AttachmentList
                jwt={this.props.jwt}
                search_query={this.state.search_query}
                selected_brandfolder={this.props.selected_brandfolder}
            />
        );
    }

    render() {
        return (
            <div className="adobe-attachment-browser">
                {this.renderSearchNav()}
                {this.renderAttachmentList()}
            </div>
        );
    }
}
